import * as React from "react";
import {ProgressBar} from "primereact/progressbar";
import {useSelector} from "react-redux";
import {ApplicationState} from "../../store";

export const ProgressBarComponent: React.FC = () => {
  const loadingCount = useSelector(
    (state: ApplicationState) => state.loading.loadingCount
  );

  return (
    <React.Fragment>
      {loadingCount !== 0 && (
        <ProgressBar id={`progressBar`} mode="indeterminate" />
      )}
    </React.Fragment>
  );
};
